// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"59":"cookies-lazy","549":"video-gallery","565":"footer-lazy","806":"profile-page","992":"video-page"}[chunkId] + "." + {"59":"14fd5e9e6762b61f","549":"dc828a21fb5eb58e","565":"e8089ab152244d6c","806":"7c81f51c4af0c6f1","992":"8a8ed3a01c0105ff"}[chunkId] + ".chunk.js";
};